import { useCallback, useRef, useState } from "react";
import { useSession } from "../context/SessionContext";
import { Company } from "../types/company.types";

export function useCompanySelectionPrompt() {
  const { metadata } = useSession();
  const [isPromptVisible, setIsPromptVisible] = useState(false);
  const resolverRef = useRef<((companies: Company[]) => void) | null>(null);

  // Pergunta ao médico se ele quer inserir empresas vinculadas neste pedido.
  // Mesmo sem nenhuma empresa vinculada ainda, mostramos o modal: se ele
  // disser que sim, o CompanySelectDialog oferece o vínculo de uma empresa
  // ali mesmo (ver etapa "link"), sem precisar ir até Configurações.
  const promptForCompanies = useCallback((): Promise<Company[]> => {
    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setIsPromptVisible(true);
    });
  }, []);

  const handleConfirm = (selected: Company[]) => {
    setIsPromptVisible(false);
    resolverRef.current?.(selected);
    resolverRef.current = null;
  };

  const handleClose = () => {
    setIsPromptVisible(false);
    resolverRef.current?.([]);
    resolverRef.current = null;
  };

  return {
    companies: metadata.companies,
    isPromptVisible,
    promptForCompanies,
    handleConfirm,
    handleClose,
  };
}
